const Modal = ({ open, onClose, children }) => {
  return (
    <div
      onClick={onClose}
      className={`duration-1000 fixed z-10 inset-0 flex justify-center items-center transition-colors ${
        open ? "visible bg-black/20" : "invisible"
      }`}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`animate__animated animate__zoomIn bg-white rounded-xl shadow p-6 transition-all ${
          open ? "scale-100 opacity-100" : "scale-125 opacity-0"
        }`}
      >
        <button
          onClick={onClose}
          className="absolute top-0 p-1 bg-white rounded-full right-1 text-gray800 hover:bg-gray200 hover:text-gray800"
        >
          X
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
